import { Text } from '@chakra-ui/react'

import { SearchEntryPropTypes } from 'interfaces/entity.interface'

export default ({ data, app, page, entityId }: SearchEntryPropTypes) => {
  return <Text>{data.displayText}</Text>
}
